export class UserPermissionsLocationListRequest {
    public IsGroup: boolean = false;
    public LocationIDs: number[] = [];
    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}
